import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const AddCounter = () => {
    const [counterNo, setCounterNo] = useState('');
    const [warehouse, setWarehouse] = useState('');
    const [taxStyle, setTaxStyle] = useState('');
    const [exchange, setExchange] = useState('');
    const [patient, setPatient] = useState('');
    const [invoiceFormat, setInvoiceFormat] = useState('');
    const [posCustomer, setPosCustomer] = useState('');
    const [tender, setTender] = useState('');
    const [hideAttributePanel, setHideAttributePanel] = useState(false);
    const [manageDaystart, setManageDaystart] = useState(true);
    const [hideTaxDiscPanel, setHideTaxDiscPanel] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        const newCounter = {
            counter_no: counterNo,
            warehouse,
            tax_style: taxStyle,
            exchange,
            patient,
            default_invoice_print_format: invoiceFormat,
            default_pos_customer: posCustomer,
            default_tender: tender,
            hide_attribute_panel: hideAttributePanel,
            manage_daystart: manageDaystart,
            hide_tax_disc_panel: hideTaxDiscPanel,
        };

        fetch(`${BASE_URL}counters`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(newCounter),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    alert("Counter added successfully!");
                    navigate('/CounterList'); // Redirect to Counter List page
                } else {
                    alert("Failed to add counter.");
                }
            })
            .catch(error => console.error('Error adding counter:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Counter</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form Section */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Counter Information</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="counterNo">Counter No</label>
                                                <input
                                                    type="text"
                                                    id="counterNo"
                                                    className="form-control"
                                                    placeholder="Enter counter number"
                                                    value={counterNo}
                                                    onChange={(e) => setCounterNo(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="warehouse">Warehouse</label>
                                                <input
                                                    type="text"
                                                    id="warehouse"
                                                    className="form-control"
                                                    placeholder="Enter warehouse name"
                                                    value={warehouse}
                                                    onChange={(e) => setWarehouse(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="taxStyle">Tax Style</label>
                                                <input
                                                    type="text"
                                                    id="taxStyle"
                                                    className="form-control"
                                                    placeholder="Enter tax style"
                                                    value={taxStyle}
                                                    onChange={(e) => setTaxStyle(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="exchange">Exchange</label>
                                                <input
                                                    type="text"
                                                    id="exchange"
                                                    className="form-control"
                                                    placeholder="Enter exchange status"
                                                    value={exchange}
                                                    onChange={(e) => setExchange(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="patient">Patient</label>
                                                <input
                                                    type="text"
                                                    id="patient"
                                                    className="form-control"
                                                    placeholder="Enter patient name"
                                                    value={patient}
                                                    onChange={(e) => setPatient(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="invoiceFormat">Invoice Format</label>
                                                <input
                                                    type="text"
                                                    id="invoiceFormat"
                                                    className="form-control"
                                                    placeholder="Enter invoice format"
                                                    value={invoiceFormat}
                                                    onChange={(e) => setInvoiceFormat(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="posCustomer">POS Customer</label>
                                                <input
                                                    type="text"
                                                    id="posCustomer"
                                                    className="form-control"
                                                    placeholder="Enter POS customer code"
                                                    value={posCustomer}
                                                    onChange={(e) => setPosCustomer(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="tender">Tender</label>
                                                <input
                                                    type="text"
                                                    id="tender"
                                                    className="form-control"
                                                    placeholder="Enter tender method"
                                                    value={tender}
                                                    onChange={(e) => setTender(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="hideAttributePanel"
                                                    checked={hideAttributePanel}
                                                    onChange={() => setHideAttributePanel(!hideAttributePanel)}
                                                />
                                                <label className="form-check-label" htmlFor="hideAttributePanel">
                                                    Hide Attribute Panel
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="manageDaystart"
                                                    checked={manageDaystart}
                                                    onChange={() => setManageDaystart(!manageDaystart)}
                                                />
                                                <label className="form-check-label" htmlFor="manageDaystart">
                                                    Manage Daystart
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="hideTaxDiscPanel"
                                                    checked={hideTaxDiscPanel}
                                                    onChange={() => setHideTaxDiscPanel(!hideTaxDiscPanel)}
                                                />
                                                <label className="form-check-label" htmlFor="hideTaxDiscPanel">
                                                    Hide Tax Discount Panel
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-end mt-4">
                                        <button type="submit" className="btn btn-primary">Add Counter</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddCounter;
